import * as types from './types';

export const incrementCounter = () => ({ type: types.INCREMENT });
export const incrementCounterSuccess = () => ({
  type: types.INCREMENT_SUCCESS,
});
export const decrementCounter = () => ({ type: types.DECREMENT });
export const incrementCounterAsync = () => ({ type: types.INCREMENT_ASYNC });
